import React, { useState } from "react";
import TableChartIcon from "@mui/icons-material/TableChart";
import { BsTable } from "react-icons/bs";
import { FaListAlt } from "react-icons/fa";
import BoxShadow from "../../../../../../Common/Components/BoxShadow";
const SelectType = ({ form, setForm }) => {
  let types = [
    {
      label: "تکرار یک روز",
      key: "table",
      icon: key => (
        <BsTable
          style={{
            color: form.show_model == "table" ? "#1976d2" : "#000",
          }}
          size={94}
        />
      ),
    },
    {
      label: "تکرار یک هفته",
      key: "list",
      icon: key => (
        <FaListAlt
          style={{
            color: form.show_model == "list" ? "#1976d2" : "#000",
          }}
          size={100}
        />
      ),
    },
  ];
  return (
    <BoxShadow
      style={{
        marginTop: "20px",
      }}
    >
      <div className="d-flex justify-content-center">
        {types &&
          types.map(({ label, key, icon }) => {
            return (
              <>
                <button
                  className="mx-5"
                  style={{
                    border: "none",
                    backgroundColor: "transparent",
                  }}
                  value={key}
                  aria-label="laptop"
                  onClick={() => {
                    setForm({ ...form, show_model: key });
                  }}
                  key={key}
                >
                  {icon(key)}
                  <h6
                    className="text-center"
                    style={{ color: "rgba(0,0,0,0.8)" }}
                  >
                    {label}
                  </h6>
                </button>
              </>
            );
          })}{" "}
      </div>
    </BoxShadow>
  );
};

export default SelectType;
